import {
  take,
  call,
  put,
  select,
  cancel,
  delay,
  takeLatest
} from "redux-saga/effects";

import { FETCH_COUNTRY_SITES } from "./constants";
import SitesApi from "./api";
import * as actions from "./actions";

const mockData = {
  count: 30,
  result: {
    states: {
      count: 430,
      data: [
        {
          state: "new york",
          sites: [
            {
              "site_name": "University of California San Diego School of Medicine",
              "site_state": "California",
              "site_address": "",
              "site_email": "irubio@ucsd.edu",
              "site_id": 3692,
              "site_status": "Recruiting",
              "site_phone": "858-822-5751",
              "site_location": {
              "lat": 32.8283259,
              "lng": -117.255854
              },
              "site_eligibility": "/clinicaltrial/932/parkinsons-disease-antigen-presentation-lymphocyte-response/eligibility/?language=en"
              
            },{
              "site_name": "Columbia University Medical Center",
              "site_state": "New York",
              "site_address": "",
              "site_email": "yx2344@columbia.edu",
              "site_id": 3694,
              "site_status": "Recruiting",
              "site_phone": "646-774-5023",
              "site_location": {
              "lat": 40.8409822,
              "lng": -73.9447994
              },
              "site_eligibility": "/clinicaltrial/932/parkinsons-disease-antigen-presentation-lymphocyte-response/eligibility/?language=en"
              },
            {}
          ]
        }
      ]
    }
  }
}


export function* fetchCountrySitesAPI(action) {
  const { trial_id, language, country} = action;
  try {
    yield put(actions.fetchCountrySitesRequest());
    const [promise, cancelRequest] = yield SitesApi.getSites({
      trial_id,
      language,
      country
    });
    const { count, result = {} } = yield promise;
    
    yield put(
      actions.fetchCountrySitesSuccess({
        data: result.states.data,
        count,
        total: result.states.count 
      })
    );
  } catch (error) {
    //mock
    const { count, result = {} } = yield Promise.resolve(mockData);
    yield put(
      actions.fetchCountrySitesSuccess({
        data: result.states.data,
        count,
        total: result.states.count 
      })
    );
    //mock end
    yield put(actions.fetchCountrySitesError(error.message));
  } finally {
    //    if (yield cancelled()) {
    //      c.abort();
    //    }
  }
}

export function* siteCountryFetchWatcher() {
  yield takeLatest(FETCH_COUNTRY_SITES, fetchCountrySitesAPI);
}

export default [siteCountryFetchWatcher()];
